module.exports = __webpack_public_path__ + "media/images/sp/visit_reserve/about-planner-011fa2f0c40ad30f803c6addf826f0b1.png";